module.exports = __webpack_public_path__ + "static/media/pet-default.b3506cc7.png";